module.exports = __webpack_public_path__ + "img/BSapper64_ua.e0ecac6a.webp";